// exam-page.js: browser entry for the mock-exam page. Bundled by esbuild → dist/assets/exam.js.
// Builds one exam from a seed (shareable via ?seed=), renders every question, and on submit
// scores it with the real PPL rules and reveals the answers. Only DOM code lives here; the
// assembly + scoring is the pure engine in exam.js.

import { buildExam, scoreExam, PASS_PCT } from './exam.js';

const $ = (id) => document.getElementById(id);

const params = new URLSearchParams(location.search);
const seed = ((Number(params.get('seed')) || (Date.now() >>> 0)) >>> 0);
const { questions } = buildExam(seed);

const SECTION_LABEL = {
  'air-law': 'Air Law',
  navigation: 'Navigation',
  meteorology: 'Meteorology',
  aeronautics: 'Aeronautics',
};

function render() {
  $('seed').textContent = `seed ${seed}`;
  const box = $('questions');
  box.replaceChildren();
  let lastSection = null;
  questions.forEach((q, i) => {
    if (q.section !== lastSection) {
      const h = document.createElement('h2');
      h.textContent = SECTION_LABEL[q.section] ?? q.section;
      box.appendChild(h);
      lastSection = q.section;
    }
    const fs = document.createElement('fieldset');
    fs.className = 'q';
    fs.dataset.index = i;
    const legend = document.createElement('legend');
    legend.className = 'stem';
    legend.textContent = `${i + 1}. ${q.stem}`;
    fs.appendChild(legend);
    q.options.forEach((o, j) => {
      const label = document.createElement('label');
      label.className = 'opt';
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = `q${i}`;
      input.value = j;
      label.append(input, ` ${o.text}`);
      fs.appendChild(label);
    });
    box.appendChild(fs);
  });
}

const answers = () =>
  questions.map((_, i) => {
    const checked = document.querySelector(`input[name="q${i}"]:checked`);
    return checked ? Number(checked.value) : null;
  });

function grade() {
  const chosen = answers();
  const result = scoreExam(questions, chosen);

  // Reveal correct/wrong on every option and lock the form.
  document.querySelectorAll('fieldset.q').forEach((fs) => {
    const i = Number(fs.dataset.index);
    const q = questions[i];
    [...fs.querySelectorAll('label.opt')].forEach((label, j) => {
      label.querySelector('input').disabled = true;
      if (q.options[j].correct) label.classList.add('correct');
      else if (j === chosen[i]) label.classList.add('wrong');
    });
  });

  const rows = Object.entries(result.sections)
    .map(
      ([s, v]) =>
        `<li>${SECTION_LABEL[s] ?? s}: ${v.correct}/${v.total} (${v.pct.toFixed(0)}%) ${v.pass ? '✓' : '✗'}</li>`,
    )
    .join('');
  const r = $('results');
  r.innerHTML =
    `<h2>${result.pass ? 'PASS' : 'FAIL'}: ${result.correct}/${result.total} (${result.overallPct.toFixed(0)}%)</h2>` +
    `<p class="tag">Pass needs ${PASS_PCT}% overall and ${PASS_PCT}% in every section.</p><ul>${rows}</ul>`;
  r.classList.remove('hidden');
  r.scrollIntoView({ behavior: 'smooth' });
  $('submit').disabled = true;
}

render();
$('submit').onclick = grade;
